
<template>
  <div class="cert-page">
    <div class="item" v-for="(item,index) in starCertInfo.Certificates" :key="index" @click="certDetail(item.Star)">
      <img src="../../assets/images/cert-default.png" />
      <span class="title">{{item.Name}}证书</span>
    </div>
    <cert-detail :show="certDetailShow" :level="certLevel" @closeCertDialog="closeCertDialog" v-if="certDetailShow"></cert-detail>
  </div>
</template>
<script>
import CertDetail from './components/cert-detail'
export default {
  components: { CertDetail },
  data () {
    return {
      starCertInfo: {
        Certificates: null,
        CurrentYearCaseCount: 0,
        StarItem: null,
        TotalCaseCount: 0
      },
      certLevel: 0,
      certDetailShow: false
    }
  },
  mounted () {
    this.getStarCertificateInfo()
  },
  methods: {
    getStarCertificateInfo () {
      this.$Request({
        AppID: this.GLOBAL.AppID,
        Method: 'GetUserRegisterStar'
      }).then(res => {
        this.starCertInfo = res
        //证书根据星级等级排序
        if (this.starCertInfo.Certificates) {
          this.starCertInfo.Certificates = this.starCertInfo.Certificates.sort((a, b) => { return b.Star - a.Star })
        }
      })
    },
    certDetail (level) {
      this.certLevel = level
      this.certDetailShow = true
    },
    closeCertDialog () {
      this.certDetailShow = false
    }
  }
}
</script>
<style lang="less" scoped>
.cert-page {
  display: flex;
  flex-wrap: wrap;
  margin-left: 2%;
  .item {
    width: 18%;
    text-align: center;
    margin-top: 40px;
    margin-left: 5%;
    img {
      max-width: 100%;
      max-height: 100%;
    }
    .title {
      color: #666666;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/views/member/all-certificates.vue